import { add, listen, qs, qsa, remove, toggle } from "@fluorescent/dom";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import { createFocusTrap } from "focus-trap";

const selectors = {
  collection: "[data-collection]",
  image: "[data-image]",
  overlay: "[data-overlay]",
  trigger: "[data-trigger]",
  submenu: "[data-submenu]",
};

export default function MegaNavLegacy(node) {
  const image = qs(selectors.image, node);
  const parents = qsa(selectors.trigger, node);
  const submenus = qsa(selectors.submenu, node);
  const collections = qsa(selectors.collection, node);
  const focusTrap = createFocusTrap(node);

  const images = qsa(".image", node);
  const defaultImage = qs(".image--mega-nav-legacy-image", node);

  const showImages = node.dataset.showImages === "true";

  let imageOpen = showImages;

  const events = [
    // Click on the overlay and close mega nav
    listen(qs(selectors.overlay, node), "click", close),

    // Click on a parent item and show child nav
    listen(parents, "click", e => {
      e.preventDefault();
      const { trigger: triggerId } = e.currentTarget.dataset;

      // Hide the image
      if (showImages) {
        remove(image, "visible");
        remove(defaultImage, "active");
        imageOpen = false;
      }

      submenus.forEach(menu => {
        const { submenu: id } = menu.dataset;
        toggle(menu, "visible", id === triggerId);
        menu.toggleAttribute("hidden", id !== triggerId);

        if (id === triggerId) {
          qs("a", menu).focus();
        }
      });
    }),

    // Show image when hovering over some link items
    showImages &&
      listen(collections, "mouseover", e => {
        const { collection } = e.currentTarget.dataset;
        images.forEach(image => {
          toggle(
            image,
            "active",
            image.classList.contains(`image--${collection}`)
          );
        });

        if (!imageOpen) {
          add(image, "visible");
        }
      }),

    // Hide image when hover removed
    showImages &&
      listen(collections, "mouseout", () => {
        remove(images, "active");
        defaultImage && toggle(defaultImage, "active", imageOpen);
        toggle(image, "visible", imageOpen);
      }),

    // Close on escape
    listen(node, "keydown", ({ keyCode }) => {
      if (keyCode === 27) close();
    }),
  ].filter(Boolean);

  function open(options = {}) {
    add(node, "active");

    if (options.leftPosition) {
      let leftPosition = options.leftPosition;

      // Avoid dropdown from being displayed off
      const edgeMargin = 30;
      const rect = node.getBoundingClientRect();
      const viewportWidth = window.innerWidth;

      if (rect && leftPosition + rect.width + edgeMargin > viewportWidth) {
        leftPosition = viewportWidth - rect.width - edgeMargin;
      }
      node.style.left = `${leftPosition}px`;
    }

    setTimeout(() => {
      focusTrap.activate();
      disableBodyScroll(node, { reserveScrollBarGap: true });
      add(node, "visible");
      node.removeAttribute("hidden");

      showImages && add(defaultImage, "active");
    }, 50);
  }

  function close() {
    remove(node, "visible");
    node.setAttribute("hidden", "");

    setTimeout(() => {
      remove(node, "active");
      enableBodyScroll(node);
      focusTrap.deactivate();

      events.forEach(evt => evt());
    }, 350);
  }

  return { open, close };
}
